import CookieConsent from "react-cookie-consent";
import "./DefaultConsent.scss";

const DefaultConsent = () => (
  <CookieConsent
    location="bottom"
    buttonText="Aceitar"
    declineButtonText="Rejeitar"
    cookieName="cookies-accepted"
    style={{
      background: "#333",
      color: "#fff",
      borderRadius: "10px",
      zIndex: 1000,
    }}
    buttonStyle={{
      color: "#fff",
      background: "#007bff",
      fontSize: "14px",
      borderRadius: "5px",
      padding: "10px 20px",
      margin: "5px",
    }}
    declineButtonStyle={{
      color: "#fff",
      background: "#dc3545",
      fontSize: "14px",
      borderRadius: "5px",
      padding: "10px 20px",
      margin: "5px",
    }}
    expires={150}
    onAccept={() => {
      console.log("Cookies aceitos!");
    }}
    onDecline={() => {
      console.log("Cookies rejeitados!");
    }}
  >
    Este site usa cookies para melhorar sua experiência. <br />
    Ao continuar, você concorda com nosso uso de cookies conforme descrito em{" "}
    <a
      href="/cookies-policy" // Substitua pelo link da sua política de cookies
      target="_blank" // Abre o link em uma nova aba
      rel="noopener noreferrer" // Melhora a segurança ao abrir links em novas abas
      className="cookie-consent-link" // Aplica a classe CSS
    >
      Política de Cookies
    </a>
    .
  </CookieConsent>
);

export default DefaultConsent;
